import React from 'react';
import ProductCategorization from '../components/mainPerformance/ProductCategorization';
import SalesTrend from '../components/mainPerformance/SalesTrend';
import ProductCategorySalesTrend from '../components/club/ProductCategorySalesTrend';
import DashboardSectionAnchor from '../components/ui/DashboardSectionAnchor';
import { TimePeriod } from '../types/api';

interface SalesDashboardProps {
  branchId?: number;
  timeRange?: string;
  apiTimeRange?: TimePeriod;
}

const SalesDashboard: React.FC<SalesDashboardProps> = ({
  branchId,
  timeRange = 'last6Months',
  apiTimeRange = '6months'
}) => {
  if (!branchId) {
    return (
      <div className="container-dashboard" dir="rtl">
        <div className="flex flex-col items-center justify-center min-h-[300px]">
          <div className="text-lg text-content-secondary">برای دیدن این داشبورد، ابتدا شعبه را انتخاب کنید.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-dashboard">
      <div className="space-y-8 md:space-y-10 animate-enter-up">
        <h1 className="title-dashboard">فروش</h1>
        <DashboardSectionAnchor sectionId="sales-trend">
          <SalesTrend branchId={branchId} timeRange={timeRange} />
        </DashboardSectionAnchor>
        <DashboardSectionAnchor sectionId="product-category-sales-trend">
          <ProductCategorySalesTrend branchId={branchId} timeRange={apiTimeRange} />
        </DashboardSectionAnchor>
        <DashboardSectionAnchor sectionId="product-categorization">
          <ProductCategorization branchId={branchId} timeRange={timeRange} />
        </DashboardSectionAnchor>

      </div>
    </div>
  );
};

export default SalesDashboard;
